<template>
<!--TODO: Enable when we upgrade to Nuxt 3.12+ ..-->
<!-- <NuxtRouteAnnouncer /> -->
<NuxtLayout>
    <NuxtPage />
</NuxtLayout>
</template>
